import { IDetailsChildRoute, IDetailsSubRoutes } from "../abstractions";

export function isSubRoute<TData>(
  route: IDetailsChildRoute<TData>): route is IDetailsSubRoutes<TData> {
  return Object.prototype.hasOwnProperty.call(route, 'routes');
}
